"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.93,0H2.41a.56.56,0,0,0-.63.64V20.15a.56.56,0,0,0,.63.64H8.8L12,23.94a.24.24,0,0,0,.32,0l3.21-3.15h6.39a.56.56,0,0,0,.63-.64V.64A.56.56,0,0,0,21.93,0Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.93,9.2a2.47,2.47,0,0,1-.82,2,3.5,3.5,0,0,1-2.34.7H12v2.9H10.3V6.66h2.6a3.46,3.46,0,0,1,2.26.64A2.33,2.33,0,0,1,15.93,9.2ZM12,10.49h.57a1.88,1.88,0,0,0,1.19-.31,1.12,1.12,0,0,0,.4-.92,1.16,1.16,0,0,0-.34-.9,1.56,1.56,0,0,0-1-.29H12Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.35,1.9a8.18,8.18,0,1,0,8.18,8.18A8.19,8.19,0,0,0,12.35,1.9Zm0,1.07A7.06,7.06,0,0,1,17,4.69l-10,10A7.11,7.11,0,0,1,12.35,3Zm0,14.22a7,7,0,0,1-4.63-1.73l10-10a7.1,7.1,0,0,1-5.38,11.74Z",
    fill: "#fff"
  }));
};

exports["default"] = _default;